<template>
    <div class="container">
        <el-button type="primary" size="mini" @click="getdata">选择文章</el-button>
        <el-dialog
            title="文章列表"
            :visible.sync="showdialog"
            width="1200px">

            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="文章类型">
                            <el-select v-model="form.source" placeholder="请选择文章类型" clearable filterable>
                                <el-option label="公众号" value="公众号"></el-option>
                                <el-option label="文章" value="文章"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="文章名称">
                            <el-input v-model="form.keyword" placeholder="文章的名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="title" label="文章标题" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="s">
                                <el-button type="primary" size="mini" @click="add(s.row)" plain>关联</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'ProjectArticle',
        data() {
            return {
                showdialog: false,
                form: {
                    source: '公众号',
                    keyword: '',
                },
                tableData: [],
                pageNo: 1,
                pagesize: 10,
                total: 0,
            }
        },
        props:{
            city:{
                type:String,
                default:'武汉'
            }
        },
        methods: {
            add(item) {
                item.source = this.form.source;
                this.$emit('addArticle', item);
                this.showdialog = false;
            },
            confirm() {
                this.pageNo = 1;
                this.getdata();
            },
            getdata() {
                this.showdialog = true;
                var params = {
                    source: this.form.source,
                    keyword: this.form.keyword,
                    pageNo: this.pageNo,
                    pagesize: this.pagesize,
                    city: this.city,
                }

                this.$api.getAllArticleBySource(params).then(
                    data=>{
                        let {list, total} = data;
                        this.tableData = list;
                        this.total = total;
                    }
                )
            },
            currentChange(page) {
                this.pageNo = page;
                this.getdata();
            },
        },
    }
</script>

<style lang="scss" scoped>
.container{
    text-align: left;
}
.base-warp{
    text-align: left;
}
</style>